import { register } from '!/repository'
import { model as authorizeModel } from '~/features/payment/authorize'

register(authorizeModel.$authorizePopupIsOpened, '$authorizePopupIsOpened')

register(authorizeModel.$currentAuthorizeStep, '$currentAuthorizeStep')

register(
  authorizeModel.selectRememberCardCheckbox,
  'selectRememberCardCheckbox'
)
register(authorizeModel.$rememberCreditCardValue, '$rememberCreditCardValue')
register(authorizeModel.confirmPaymentWithNewCard, 'confirmPaymentWithNewCard')
register(authorizeModel.selectCreditCard, 'selectCreditCard')
register(
  authorizeModel.confirmPaymentWithSavedCard,
  'confirmPaymentWithSavedCard'
)
register(authorizeModel.$selectedCreditCard, '$selectedCreditCard')
register(authorizeModel.addNewCreditCard, 'addNewCreditCard')
